import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import FieldDate from '../common/FieldDate';
import FieldSelect from '../common/FieldSelect';
import FieldMultiSelect from '../common/FieldMultiSelect';
import FieldSearchSelect from '../common/FieldSearchSelect';
import Util from '../../util/Util';
import Calculate from '../../util/Calculate';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';
import ValidationController from '../../controller/ValidationController';
import ApiUiController from '../../controller/ApiUiController';
import SalesOrderAPI from '../../api/SalesOrderAPI';
import RoomAPI from '../../api/RoomAPI';
import FieldModule from '../common/FieldModule';
import SalesOrderUpdateProject from './SalesOrderUpdateProject';
import SalesOrderCalculation from './SalesOrderCalculation';
import SalesOrderAddEditCustom from './SalesOrderAddEditCustom';

import './SalesOrder.css';
import SalesOrderController from '../../controller/SalesOrderController';
import FieldNumber from '../common/FieldNumber';
import FieldDecimal from '../common/FieldDecimal';
import FieldText from '../common/FieldText';
import FieldTextArea from '../common/FieldTextArea';
import FieldDateTime from '../common/FieldDateTime';
import FieldToggle from '../common/FieldToggle';
import FieldAddress from '../common/FieldAddress';

class SalesOrderUpdate extends React.Component {

  static SaleTypeSale = 1;
  static SaleTypeRent = 2;
  
  static PropertyTypeProject = 1;
  static PropertyTypeProperty = 2;

  constructor(props) {
    super(props);

    this.IsInventory = reactLocalStorage.get(Const.ProjectInventory);

    this.user = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    const models = reactLocalStorage.getObject(Const.Model);
    this.model = models.sales_order;

    const modelNo = parseInt(props.match.params.modelNo);
    const modelId = parseInt(props.match.params.modelId);
    this.id = parseInt(props.match.params.saleId);

    let currency = models.currency.options.find(opt => opt.is_default === Const.True);
    currency = currency ? currency.value : 0;
    const today = Util.dateToServerDateTime(new Date());


    let sale = SalesOrderController.addModel(this.model.fields);
  
    sale = { ...sale,
      model_no: modelNo, model_id: modelId, currency, start_date: today,
      end_date: today, probability: 1, sales_type: 1, property_type: 2, 
      responsible_person: this.user 
    };

    this.state = { sale , inValid: { }, changed: false, inApiCall: this.id !== 0 };

    const fields = this.model.fields;
    //fields.validity_date = { ...fields.validity_date, api_mandate: 0, editable: 0 };
    fields.property = { ...fields.property, api_mandate: 1, editable: 1 };
    fields.project = { ...fields.project, api_mandate: 0, editable: 0 };
    fields.tower = { ...fields.tower, api_mandate: 0, editable: 0 };
    fields.room = { ...fields.room, api_mandate: 0, editable: 0 };

    this.base = this.props.match.path
    this.base = this.base.substring(0, this.base.indexOf('/add-edit'));
  }

  componentDidMount() {
    if(this.id !== 0) { 
      SalesOrderAPI.get(this.id, this.onReceived, this.onFail); 
    } 
  }

  onFail = (res) => {this.setState({ ...this.state, inApiCall: false }); Util.showError(res);};
  onReceived = sale => {
    const fields = this.model.fields;
    if(this.IsInventory && sale.project && sale.tower && sale.room) {
      if(sale.sales_type === SalesOrderUpdate.SaleTypeSale) {
        fields.validity_date = { ...fields.validity_date, api_mandate: 0, editable: 0 };
      } else if(sale.sales_type === SalesOrderUpdate.SaleTypeRent) {
        fields.validity_date = { ...fields.validity_date, api_mandate: 1, editable: 1 };
      }
  
      if(sale.property_type === SalesOrderUpdate.PropertyTypeProperty) {
        fields.property = { ...fields.property, api_mandate: 1, editable: 1 };
        fields.project = { ...fields.project, api_mandate: 0, editable: 0 };
        fields.tower = { ...fields.tower, api_mandate: 0, editable: 0 };
        fields.room = { ...fields.room, api_mandate: 0, editable: 0 };
      } else if(this.IsInventory && sale.property_type === SalesOrderUpdate.PropertyTypeProject) {
        fields.property = { ...fields.property, api_mandate: 0, editable: 0 };
        fields.project = { ...fields.project, api_mandate: 1, editable: 1 };
        fields.tower = { ...fields.tower, api_mandate: 1, editable: 1 };
        fields.room = { ...fields.room, api_mandate: 1, editable: 1 };
      } else if(!this.IsInventory && sale.property_type === SalesOrderUpdate.PropertyTypeProject) {
        fields.property = { ...fields.property, api_mandate: 1, editable: 1 };
        fields.project = { ...fields.project, api_mandate: 1, editable: 1 };
        fields.tower = { ...fields.tower, api_mandate: 0, editable: 0 };
        fields.room = { ...fields.room, api_mandate: 0, editable: 0 };
      }

      this.setState({ ...this.state, sale: { ...sale } });
      RoomAPI.getRoom(sale.room, this.onRoomReceived, this.onFail);
    } else {
      this.setState({ ...this.state, sale: { ...sale }, inApiCall: false });
    }
  }

  onRoomReceived = res => {
    if(res.room) {
      this.model.fields.room['options'] = [{ label: res.room.room_name , value: res.room.id }];
    }
    if(res.tower) {
      this.model.fields.tower['options'] = [{ label: res.tower.tower_name , value: res.tower.id }];
    }
    if(res.property) {
      this.model.fields.property['options'] = [{ label: res.property.name , value: res.property.id }];
    }
    this.setState({ ...this.state, inApiCall: false });
  }
  

  onChange = (field, value, property) => {
    let sale = { ...this.state.sale };
    sale[field] = value;

    const fields = this.model.fields;
    if(field === 'sales_type' && value === SalesOrderUpdate.SaleTypeSale) {
      fields.validity_date = { ...fields.validity_date, api_mandate: 0, editable: 0 };
    } else if(field === 'sales_type' && value === SalesOrderUpdate.SaleTypeRent) {
      fields.validity_date = { ...fields.validity_date, api_mandate: 1, editable: 1 };
    }

    if(field === 'property_type' && value === 2) {
      fields.property = { ...fields.property, api_mandate: 1, editable: 1 };
      fields.project = { ...fields.project, api_mandate: 0, editable: 0 };
      fields.tower = { ...fields.tower, api_mandate: 0, editable: 0 };
      fields.room = { ...fields.room, api_mandate: 0, editable: 0 };
      sale = { ...sale, property: 0, project: 0, tower: 0, room: 0 };
    } else if(field === 'property_type' && value === 1 && this.IsInventory) {
      fields.property = { ...fields.property, api_mandate: 0, editable: 0 };
      fields.project = { ...fields.project, api_mandate: 1, editable: 1 };
      fields.tower = { ...fields.tower, api_mandate: 1, editable: 1 };
      fields.room = { ...fields.room, api_mandate: 1, editable: 1 };
      sale = { ...sale, property: 0, project: 0, tower: 0, room: 0 };
    } else if(field === 'property_type' && value === 1 && !this.IsInventory) {
      fields.property = { ...fields.property, api_mandate: 1, editable: 1 };
      fields.project = { ...fields.project, api_mandate: 1, editable: 1 };
      fields.tower = { ...fields.tower, api_mandate: 0, editable: 0 };
      fields.room = { ...fields.room, api_mandate: 0, editable: 0 };
      sale = { ...sale, property: 0, project: 0, tower: 0, room: 0 };
    }

    if(field === 'property' && property) {
      if(property.carpet_area) sale.carpet_area = property.carpet_area;
      if(property.build_area) sale.build_area = property.build_area;
      if(property.incentives) sale.incentives = property.incentives;
      if(property.price) sale.price = property.price;
      //if(property.society_charges) sale.society_charges = property.society_charges;
      if(property.parking_charges) sale.parking_charges = property.parking_charges;
      //if(property.other_charges) sale.other_charges = property.other_charges;
      if(property.gst_percen) sale.gst_p = property.gst_percen;

      if(property.commission_p) sale.commission_p = property.commission_p;
      if(property.agreement_price) sale.agreement_price = property.agreement_price;
      if(property.development_charges) sale.development_charges = property.development_charges;
      if(property.stamp_duty_p) sale.stamp_duty_p = property.stamp_duty_p;
    }

    sale = this.onChangeCalculate(-1, sale, field);

    this.setState({ ...this.state, sale, inValid: {}, changed: !this.state.changed });
  }

  onSave = () => {
    const sale = {...this.state.sale, id: this.id};
    let inValid = ValidationController.validate(this.model.fields, sale);
    if(inValid === null) {
      this.setState({ ...this.state, inApiCall: true });
      SalesOrderAPI.save(sale, this.onSaved, this.onFail);
    } else { 
      const message = Util.failure(inValid);
      Util.showError(message);
      this.setState({ ...this.state, inValid: { ...inValid } });
    }
  }

  onSaved = res => {
    Util.showNotification( 'Successful', 'Sales Order saved successfully', 'success');
    this.setState({ ...this.state, inApiCall: false });
    this.props.navigate(`${this.base}/preview/${res.id}`);
  }

  onChangeCalculate = (index, sale, skipField) => {
    const keys = Object.keys(this.model.fields);
    let inner = [];
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (skipField !== key
        && key.includes(Const.T_Product) && key.includes(Const.Opt)
        && this.model.fields[key].calculate && this.model.fields[key].calculate !== '') {
        inner.push(key);
      }
    }
    
    inner = inner.sort((left, right) => {
      if (this.model.fields[left].field_order > this.model.fields[right].field_order) return 1;
      else if (this.model.fields[left].field_order < this.model.fields[right].field_order) return -1;
      else return 0;
    });

    if(index > -1) {
      for (let i = 0; i < inner.length; i++) {
        const field = inner[i];
        const type = this.model.fields[field].field_type;
        const fieldKeys = this.model.fields[field].field_key.split('~');

        if (type === Const.Discount || type === Const.Commission || type === Const.Tax) {
          const tmp = JSON.parse(this.model.fields[field].calculate);
          if(!sale.products[index][fieldKeys[1]]) {
            sale.products[index][fieldKeys[1]] = {}
          }
          if(tmp) {
            if(tmp.pre && tmp.pre.includes(skipField)) {
              sale.products[index][fieldKeys[1]][Const.TypePre] = Calculate.calculate(this.model.fields, 
                index, sale, tmp.pre);
            }
            if(tmp.amount && tmp.amount.includes(skipField)) {
              sale.products[index][fieldKeys[1]][Const.TypeAmt] = Calculate.calculate(this.model.fields, 
                index, sale, tmp.amount);
            }
          } else {
            sale.products[index][fieldKeys[1]][Const.TypePre] = 0;
            sale.products[index][fieldKeys[1]][Const.TypeAmt] = 0;
          }
        } else {
          const calculate = this.model.fields[field].calculate;
          if(calculate && calculate.includes(skipField)) {
            sale.products[index][fieldKeys[1]] = Calculate.calculate(this.model.fields, index, sale, calculate);
          }
        }
      }
    }
    inner = [];
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (skipField !== key
        && !key.includes(Const.T_Product) && !key.includes(Const.Opt)
        && this.model.fields[key].calculate && this.model.fields[key].calculate !== '') {
        inner.push(key);
      }
    }
    inner = inner.sort((left, right) => {
      if (this.model.fields[left].field_order > this.model.fields[right].field_order) return 1;
      else if (this.model.fields[left].field_order < this.model.fields[right].field_order) return -1;
      else return 0;
    });
    
    for (let i = 0; i < inner.length; i++) {
      const field = inner[i];
      const calculate = this.model.fields[field].calculate;
      if(calculate && calculate.includes(skipField)) {
        sale[field] = Calculate.calculate(this.model.fields, index, sale, calculate);
      }
    }
    return sale;
  }

  onChangeRooms = options => this.model.fields.tower.options = options;
  
  renderCalculationAndCustomFields = () => {
    const { inValid, sale } = this.state;
    const fields = this.model.fields;
    const calculationFields = SalesOrderCalculation.Fields;
    const customFieldKeys = Object.keys(fields).filter(key => key.startsWith('custom_') && fields[key].visible);
    const allFieldsToRender = [...calculationFields, ...customFieldKeys];
    const sortedFields = Object.keys(fields)
      .filter(key => allFieldsToRender.includes(key) && fields[key].visible)
      .sort((a, b) => fields[a].field_order - fields[b].field_order);

      if(sortedFields.length ===0) return null;

        return sortedFields.map(fieldKey => {
      const field = fields[fieldKey];
      const value = sale[fieldKey];
      
      const commonProps = {
        key: fieldKey,
        id: fieldKey,
        field: field,
        value: value,
        onValueChange: this.onChange,
        inValid: inValid
      };
      
      // Render based on field type
      if (field.field_type === 'number') {
        return <FieldNumber {...commonProps} />;
      } else if (field.field_type === 'decimal') {
        return <FieldDecimal {...commonProps} />;
      } else if (field.field_type === 'text') {
        return <FieldText {...commonProps} />;
      } else if (field.field_type === 'textarea') {
        return <FieldTextArea {...commonProps} />;
      } else if (field.field_type === 'date') {
        return <FieldDate {...commonProps} />;
      } else if (field.field_type === 'datetime') {
        return <FieldDateTime {...commonProps} />;
      } else if (field.field_type.includes('select')) {
        if (field.field_type.includes('multiselect')) {
          return <FieldMultiSelect {...commonProps} />;
        } else {
          return <FieldSelect {...commonProps} />;
        }
      } else if (field.field_type === 'toggle') {
        return <FieldToggle {...commonProps} />;
      } else if (field.field_type === 'address') {
        return <FieldAddress {...commonProps} />;
      }
      
      // Default to text if type not recognized
      return <FieldText {...commonProps} />;
    });
  }


  render() {
    const inValid = this.state.inValid;
    const fields = this.model.fields;
    return (
      <div className="sectionform pt-4">
        <div className="container-fluid form-cont">
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              
              <FieldModule key="model" id="model" field={fields.model}
                value={this.state.sale} />

              <FieldDate key="start_date" id="start_date" field={fields.start_date}
                value={this.state.sale.start_date} onValueChange={this.onChange}
                inValid={inValid} />
              <FieldDate key="end_date" id="end_date" field={fields.end_date}
                value={this.state.sale.end_date} onValueChange={this.onChange}
                inValid={inValid} />

              <FieldSelect key="currency" id="currency" field={fields.currency}
                value={this.state.sale.currency} onValueChange={this.onChange}
                inValid={inValid} />

              <FieldSelect key="probability" id="probability" field={fields.probability}
                value={this.state.sale.probability} onValueChange={this.onChange}
                inValid={inValid}/>
              
              <FieldSelect key="sales_type" id="sales_type" field={fields.sales_type}
                value={this.state.sale.sales_type} onValueChange={this.onChange}
                inValid={inValid}/>

              <FieldDate key="validity_date" id="validity_date" field={fields.validity_date}
                value={this.state.sale.validity_date} onValueChange={this.onChange}
                inValid={inValid} />

              <FieldSelect key="responsible_person" id="responsible_person"
                field={fields.responsible_person} value={this.state.sale.responsible_person}
                onValueChange={this.onChange} inValid={inValid} />

              <FieldMultiSelect key="sales_person" id="sales_person"
                field={fields.sales_person} value={this.state.sale.sales_person}
                onValueChange={this.onChange} inValid={inValid} />

            </Form>
            <Form className="row row-cols-3 lead-form">

              <FieldSelect key="property_type" id="property_type"
                field={fields.property_type} value={this.state.sale.property_type}
                onValueChange={this.onChange} inValid={inValid} />

              { this.state.sale.property_type === 2 ?
                <FieldSearchSelect key="property" id="property"
                  field={fields.property} value={this.state.sale.property}
                  onValueChange={this.onChange} inValid={inValid} project={0} /> : null
              }

              { this.state.sale.property_type === 1 ?
                <SalesOrderUpdateProject key="project" IsInventory={this.IsInventory} 
                  inValid={inValid} sale={this.state.sale} onChange={this.onChange}
                  fields={fields} onChangeRooms={this.onChangeRooms}/>
                : null
              }
            </Form>

            <Form className="row row-cols-3 lead-form">
              {this.renderCalculationAndCustomFields()}
            </Form>
            {/* <Form className="row row-cols-3 lead-form">
              <SalesOrderCalculation model={this.model} sales={this.state.sale}
                onValueChange={this.onChange} inValid={inValid} />
            </Form>

            <SalesOrderAddEditCustom model={this.model} sales={this.state.sale}
              onValueChange={this.onChange} inValid={inValid} /> */}
            <Form className="row row-cols-3 lead-form">
              <FieldSelect key="booking_pdf" id="booking_pdf" field={fields.booking_pdf} value={this.state.sale.booking_pdf} onValueChange={this.onChange} inValid={inValid}/>
            </Form>

            <div className="col-md-12 text-center btnsend">
              <Button variant="success" onClick={this.onSave}>
                { this.id === 0 ? 'Save' : 'Update' } Sale
              </Button>
            </div>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(SalesOrderUpdate);
